import React, { useEffect, useState } from "react";
import { useSubscription } from "../context/SubscriptionContext";
import apiClient from "../services/apiClient";
import { buildApiUrl } from '../services/apiHelpers';

const InvoicesStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    *, *::before, *::after { box-sizing: border-box; }
    html { overflow: hidden !important; height: 100vh; }
    body { overflow: hidden !important; height: 100vh; margin: 0; padding: 0; }
    #root { overflow: hidden !important; height: 100vh; margin: 0; padding: 0; }

    .inv-root {
      font-family: 'Inter', system-ui, sans-serif;
      background: transparent;
      height: 100vh;
      width: 100%;
      max-width: none;
      padding: 20px 20px 20px;
      color: #0f172a;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      overflow: hidden !important;
      overflow-y: hidden !important;
      overflow-x: hidden !important;
      margin: 0;
      position: relative;
    }

    /* ── PAGE HEADER ── */
    .inv-page-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1.5px solid #dde6f5;
      flex-wrap: wrap;
      flex: 0 0 auto;
    }

    .inv-header-left {
      display: flex;
      align-items: center;
      gap: 18px;
    }

    .inv-header-icon {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: linear-gradient(135deg, #1e40af 0%, #2563eb 45%, #3b82f6 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      box-shadow:
        0 10px 24px rgba(37,99,235,0.22),
        0 0 0 1px rgba(191,219,254,0.55) inset;
    }

    .inv-header-icon svg {
      width: 28px;
      height: 28px;
    }

    .inv-header-title {
      font-size: 28px;
      font-weight: 800;
      color: #0f172a;
      letter-spacing: -0.04em;
      line-height: 1.08;
      margin: 0 0 3px;
    }

    .inv-header-sub {
      font-size: 13.5px;
      color: #64748b;
      font-weight: 500;
      margin: 0;
    }

    .inv-total-pill {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
      color: #fff;
      padding: 10px 18px;
      border-radius: 36px;
      font-size: 13.5px;
      font-weight: 700;
      letter-spacing: 0.01em;
      box-shadow: 0 6px 20px rgba(37, 99, 235, 0.18);
      white-space: nowrap;
      flex-shrink: 0;
    }

    .inv-total-pill svg {
      width: 18px;
      height: 18px;
      opacity: 0.9;
    }

    /* ── SUMMARY CARDS ── */
    .inv-summary-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-bottom: 22px;
    }

    .inv-stat-card {
      background: transparent;
      border: 1px solid rgba(30,41,59,0.04);
      border-radius: 16px;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      gap: 16px;
      box-shadow: none;
      backdrop-filter: blur(6px);
    }

    .inv-stat-icon-box {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .inv-stat-icon-box svg {
      width: 22px;
      height: 22px;
    }

    .inv-stat-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: #94a3b8;
      margin-bottom: 4px;
    }

    .inv-stat-value {
      font-size: 26px;
      font-weight: 800;
      color: #0f172a;
      line-height: 1;
      letter-spacing: -0.02em;
    }

    .inv-stat-meta {
      font-size: 12px;
      color: #94a3b8;
      margin-top: 4px;
      font-weight: 500;
    }

    /* ── SEARCH & FILTER BAR ── */
    .inv-search-filter-bar {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      flex-wrap: wrap;
      flex: 0 0 auto;
    }

    .inv-search-wrap {
      flex: 1 1 280px;
      position: relative;
      min-width: 200px;
      background: #ffffff;
      border: 1px solid rgba(226,234,249,0.9);
      border-radius: 12px;
      padding: 8px 12px;
      box-shadow: 0 8px 20px rgba(15,23,42,0.04);
    }

    .inv-search-wrap svg {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 18px;
      height: 18px;
      color: #94a3b8;
      pointer-events: none;
    }

    .inv-search-input {
      width: 100%;
      padding: 6px 6px 6px 36px;
      border-radius: 8px;
      border: none;
      background: transparent;
      font-family: 'Inter', sans-serif;
      font-size: 15px;
      color: #0f172a;
      outline: none;
      transition: border-color 0.18s, box-shadow 0.18s;
    }

    .inv-search-input::placeholder { color: #94a3b8; }

    .inv-search-input:focus {
      border-color: #1d4ed8;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.16);
    }

    .inv-select-wrap {
      position: relative;
      flex: 0 0 auto;
    }

    .inv-select-wrap svg {
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      color: #64748b;
      pointer-events: none;
    }

    .inv-select {
      appearance: none;
      padding: 13px 40px 13px 16px;
      border-radius: 12px;
      border: 1.5px solid #dde6f5;
      background: #fff;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 600;
      color: #334155;
      outline: none;
      cursor: pointer;
      transition: border-color 0.18s, box-shadow 0.18s;
      min-width: 150px;
    }

    .inv-select:focus {
      border-color: #1d4ed8;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.16);
    }

    /* ── TABLE ── */
    .inv-table-card {
      background: transparent;
      border-radius: 0;
      border: none;
      overflow: hidden;
      box-shadow: none;
      flex: 1 1 auto;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 0;
    }

    .inv-content {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      overflow: hidden !important;
      min-height: 0;
    }

    .inv-table-scroll,
    .inv-card-list {
      flex: 1 1 auto;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 0;
      overflow-x: hidden;
    }

    .inv-table-scroll {
      height: 388px; /* header + 5 rows visible */
      max-height: 388px;
      padding-bottom: 0;
    }

    .inv-card-list {
      display: none;
      flex-direction: column;
      gap: 16px;
      width: 100%;
      padding-bottom: 16px;
    }

    .inv-table {
      width: 100%;
      border-collapse: collapse;
      min-width: 0;
      table-layout: auto;
    }

    .inv-table thead tr {
      background: linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 55%, #2563eb 100%);
      position: sticky;
      top: 0;
      z-index: 3;
    }

    .inv-table thead th {
      padding: 14px 18px;
      text-align: center;
      font-size: 12.5px;
      font-weight: 800;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.96);
      white-space: nowrap;
      background: transparent;
      box-shadow: 0 1px 0 rgba(255, 255, 255, 0.16) inset;
      height: 56px; /* fixed header height used in scroll calc */
    }

    .inv-table thead th:first-child {
      width: 52px;
      text-align: center;
    }

    .inv-table tbody tr {
      border-bottom: 1px solid #eef2fb;
      transition: background 0.14s ease;
      height: 66px; /* slightly reduced row height for a tighter table */
      background: transparent;
    }

    .inv-table tbody tr:last-child {
      border-bottom: none;
    }

    .inv-table tbody tr:nth-child(even) {
      background: #f8fbff; /* subtle off-white similar to Patients */
    }

    .inv-table tbody tr:hover {
      background: linear-gradient(90deg, rgba(239,246,255,0.95) 0%, rgba(255,255,255,0.98) 100%);
    }

    .inv-table td {
      padding: 15px 20px;
      font-size: 14px;
      color: #334155;
      vertical-align: middle;
      overflow-wrap: anywhere;
      text-align: center;
    }

    .inv-table td:first-child {
      text-align: center;
      font-size: 13px;
      font-weight: 600;
      color: #94a3b8;
      width: 52px;
      opacity: 0.85;
      white-space: nowrap;
    }

    /* invoice number left-align like Patients table */
    .inv-table td:nth-child(2) {
      min-width: 160px;
      max-width: 320px;
      white-space: normal;
      text-align: left;
      padding-left: 18px;
    }

    /* invoice number cell */
    .inv-num-cell {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .inv-num-icon {
      width: 34px;
      height: 34px;
      border-radius: 10px;
      background: rgba(37,99,235,0.09);
      border: 1px solid rgba(37,99,235,0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      font-size: 14px;
      color: #1d4ed8;
    }

    .inv-num-text {
      font-weight: 700;
      color: #0f172a;
      font-size: 13.5px;
    }

    /* amounts */
    .inv-amount {
      font-weight: 700;
      font-size: 14px;
      color: #0f172a;
      font-variant-numeric: tabular-nums;
    }

    .inv-amount-secondary {
      font-weight: 600;
      font-size: 13.5px;
      color: #64748b;
      font-variant-numeric: tabular-nums;
    }

    /* total amount highlighted */
    .inv-amount-total {
      font-weight: 800;
      font-size: 15px;
      color: #1d4ed8;
      font-variant-numeric: tabular-nums;
    }

    /* status badge */
    .inv-status {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.02em;
      white-space: nowrap;
    }

    .inv-status-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    .inv-status.paid {
      background: rgba(37,99,235,0.14);
      color: #1d4ed8;
      border: 1px solid rgba(37,99,235,0.22);
    }

    .inv-status.paid .inv-status-dot { background: #2563eb; }

    .inv-status.unpaid,
    .inv-status.pending,
    .inv-status.overdue {
      background: #fee2e2;
      color: #dc2626;
      border: 1px solid #fecaca;
    }

    .inv-status.unpaid .inv-status-dot,
    .inv-status.pending .inv-status-dot,
    .inv-status.overdue .inv-status-dot {
      background: #dc2626;
    }

    /* download button */
    .inv-download-btn {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      padding: 9px 18px;
      border-radius: 10px;
      border: 1.5px solid #bfdbfe;
      background: #eff6ff;
      color: #1d4ed8;
      font-family: 'Inter', sans-serif;
      font-size: 12.5px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.18s ease;
      white-space: nowrap;
    }

    .inv-download-btn svg {
      width: 14px;
      height: 14px;
    }

    .inv-download-btn:hover {
      background: #2563eb;
      border-color: #2563eb;
      color: #fff;
      box-shadow: 0 4px 14px rgba(37, 99, 235, 0.3);
      transform: translateY(-1px);
    }

    /* ── MOBILE CARDS ── */
    .inv-card-list {
      display: none;
      flex-direction: column;
      gap: 16px;
      width: 100%;
      padding-bottom: 16px;
      flex: 1 1 auto;
      min-height: 0;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }

    .inv-mobile-card {
      background: rgba(255,255,255,0.98);
      border-radius: 16px;
      border: 1px solid rgba(37,99,235,0.12);
      padding: 18px 16px;
      box-shadow: 0 12px 28px rgba(37,99,235,0.06);
      backdrop-filter: blur(12px);
      width: 100%;
      flex-shrink: 0;
    }

    .inv-mobile-card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 10px;
    }

    .inv-mobile-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 7px 0;
      border-bottom: 1px solid #f1f5f9;
      font-size: 13px;
    }

    .inv-mobile-row:last-of-type {
      border-bottom: none;
    }

    .inv-mobile-label {
      color: #94a3b8;
      font-weight: 600;
    }

    .inv-mobile-val {
      font-weight: 700;
      color: #0f172a;
    }

    .inv-mobile-footer {
      margin-top: 12px;
    }

    .inv-mobile-footer .inv-download-btn {
      width: 100%;
      justify-content: center;
      font-size: 12px;
    }

    /* ── EMPTY / NO-RESULTS ── */
    .inv-empty {
      background: rgba(255,255,255,0.98);
      border-radius: 22px;
      border: 1px solid rgba(37,99,235,0.14);
      padding: 54px 32px;
      text-align: center;
      box-shadow: 0 18px 42px rgba(15,23,42,0.08);
      backdrop-filter: blur(12px);
      max-width: 720px;
      margin: 0 auto;
    }

    .inv-empty-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      margin: 0 auto 18px;
      border-radius: 22px;
      background: rgba(37,99,235,0.08);
      opacity: 1;
    }

    .inv-empty-icon svg {
      width: 32px;
      height: 32px;
      display: block;
    }

    .inv-empty strong {
      display: block;
      font-size: 16px;
      font-weight: 700;
      color: #334155;
      margin-bottom: 6px;
    }

    .inv-empty p {
      font-size: 13.5px;
      color: #94a3b8;
      margin: 0;
    }

    /* ── LOADING ── */
    .inv-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 14px;
      height: 50vh;
    }

    .inv-spinner {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 3px solid #dde6f5;
      border-top-color: #2563eb;
      animation: inv-spin 0.7s linear infinite;
    }

    @keyframes inv-spin { to { transform: rotate(360deg); } }

    /* ── RESPONSIVE ── */
    @media (max-width: 1024px) {
      .inv-root {
        padding: 20px 22px 20px;
        height: 100vh;
        overflow: hidden !important;
      }
      .inv-page-header { flex-direction: column; align-items: stretch; }
      .inv-total-pill { width: auto; justify-content: flex-start; }
    }
      /* Tablet-specific adjustments */
      @media (max-width: 1024px) {
        .inv-table {
          min-width: 0;
          table-layout: auto;
        }
        .inv-table-scroll {
          /* allow more vertical space on tablet and let rows expand */
          max-height: calc(100vh - 300px);
        }
        .inv-table thead th { height: auto; }
        .inv-table tbody tr { height: auto; }
        .inv-table td { padding: 12px 14px; }
      }

    @media (max-width: 768px) {
      .inv-root { 
        padding: 0;
        overflow: hidden !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        height: 100vh;
        width: 100%;
        margin: 0;
      }
      .inv-page-header { 
        margin-bottom: 0;
        padding: 18px 16px 12px;
        flex: 0 0 auto;
        gap: 14px;
        border-bottom: 1.5px solid #dde6f5;
      }
      .inv-header-icon { width: 48px; height: 48px; border-radius: 14px; }
      .inv-header-icon svg { width: 24px; height: 24px; }
      .inv-header-title { font-size: 22px; }
      .inv-total-pill { width: 100%; justify-content: center; }
      .inv-summary-row { display: none; }
      .inv-search-filter-bar { 
        flex-direction: column; 
        align-items: stretch; 
        gap: 12px;
        margin-bottom: 0;
        padding: 12px 16px 16px;
        flex: 0 0 auto;
        background: transparent;
      }
      .inv-search-wrap { flex: 1 1 auto; }
      .inv-select-wrap { width: 100%; }
      .inv-search-input, .inv-select { width: 100%; }
      .inv-table-card { display: none; }
      .inv-content {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        min-height: 0;
        padding: 0;
      }
      .inv-card-list { 
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        padding: 12px 16px 16px 16px;
        gap: 16px;
        width: 100%;
      }
      .inv-root::after {
        display: none;
      }
    }

    @media (max-width: 480px) {
      .inv-root { 
        padding: 0;
        overflow: hidden !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
      }
      .inv-page-header {
        padding: 16px 14px 10px;
      }
      .inv-header-left { gap: 12px; }
      .inv-header-title { font-size: 20px; }
      .inv-header-sub { font-size: 11px; }
      .inv-search-filter-bar {
        padding: 10px 14px 14px;
      }
      .inv-card-list {
        padding: 10px 14px 16px 14px;
      }
      .inv-mobile-card {
        border-radius: 14px;
        padding: 16px 14px;
      }
    }
  `}</style>
);

/* ── Icons ── */
const IconReceipt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10 9 9 9 8 9"/>
  </svg>
);

const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const IconChevronDown = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

const IconDownload = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

const IconInvoice = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
    <polyline points="14 3 14 8 19 8"/>
    <line x1="9" y1="13" x2="15" y2="13"/>
    <line x1="9" y1="17" x2="15" y2="17"/>
  </svg>
);

const IconTotal = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <line x1="2" y1="10" x2="22" y2="10"/>
  </svg>
);

const IconEmptyState = () => (
  <svg viewBox="0 0 48 48" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="10" y="8" width="24" height="32" rx="4" fill="rgba(37,99,235,0.08)" stroke="#2563eb"/>
    <path d="M16 14h16"/>
    <path d="M16 20h12"/>
    <path d="M16 26h16"/>
    <path d="M16 32h12"/>
    <circle cx="34" cy="34" r="6" fill="rgba(37,99,235,0.18)" stroke="#2563eb"/>
    <path d="M38.5 38.5l4 4" stroke="#1d4ed8"/>
  </svg>
);

/* ══════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════ */
const SubscriptionInvoicesPage = () => {
  const [invoices, setInvoices]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [filters, setFilters]     = useState({ status: "ALL", month: "ALL", query: "" });
  const { clinicInfo } = useSubscription();
  const clinicId = clinicInfo?.id || null;

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const res = await apiClient.get(`/subscription/invoices/${clinicId}`);
        setInvoices(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        console.error("Error fetching invoices", err);
      } finally {
        setLoading(false);
      }
    };
    if (clinicId) {
      fetchInvoices();
    } else {
      setInvoices([]);
      setLoading(false);
    }
  }, [clinicId]);

  /* ── derived ── */
  const statuses = Array.from(new Set(invoices.map(i => i.status))).sort();
  const months   = Array.from(new Set(invoices.map(i => i.billingMonth))).sort((a,b) => a.localeCompare(b));

  const totalInvoices     = invoices.length;

  const searchTerm = filters.query.trim().toLowerCase();
  const filtered = invoices.filter(inv => {
    const statusOk = filters.status === "ALL" || inv.status === filters.status;
    const monthOk  = filters.month  === "ALL" || inv.billingMonth === filters.month;
    const queryOk  = searchTerm === "" ||
      inv.invoiceNumber?.toLowerCase().includes(searchTerm) ||
      inv.billingMonth?.toLowerCase().includes(searchTerm);
    return statusOk && monthOk && queryOk;
  });

  const downloadInvoice = (id) =>
    window.open(buildApiUrl(`subscription/invoice/download/${id}`), "_blank");

  const statusClass = (s) => {
    if (!s) return "";
    const l = s.toLowerCase();
    if (l === "paid")    return "paid";
    if (l === "overdue") return "overdue";
    if (l === "pending") return "pending";
    return "unpaid";
  };

  /* ── Loading ── */
  if (loading) return (
    <>
      <InvoicesStyle/>
      <div className="inv-loading">
        <div className="inv-spinner"/>
        <span style={{fontSize:14,color:"#64748b",fontWeight:500}}>Loading invoices…</span>
      </div>
    </>
  );

  return (
    <div className="inv-root">
      <InvoicesStyle/>

      {/* ════ PAGE HEADER ════ */}
      <div className="inv-page-header">
        <div className="inv-header-left">
          <div className="inv-header-icon">
            <IconReceipt/>
          </div>
          <div>
            <h1 className="inv-header-title">Invoices</h1>
            <p className="inv-header-sub">Manage billing history and download payment receipts</p>
          </div>
        </div>

        <div className="inv-total-pill">
          <IconTotal/>
          {totalInvoices} Total Invoice{totalInvoices !== 1 ? "s" : ""}
        </div>
      </div>

      {/* ════ SEARCH & FILTER BAR ════ */}
      <div className="inv-search-filter-bar">
        <div className="inv-search-wrap">
          <IconSearch/>
          <input
            className="inv-search-input"
            value={filters.query}
            onChange={e => setFilters(p => ({...p, query: e.target.value}))}
            placeholder="Search by invoice number or billing month…"
          />
        </div>

        <div className="inv-select-wrap">
          <select
            className="inv-select"
            value={filters.status}
            onChange={e => setFilters(p => ({...p, status: e.target.value}))}
          >
            <option value="ALL">All Statuses</option>
            {statuses.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <IconChevronDown/>
        </div>

        <div className="inv-select-wrap">
          <select
            className="inv-select"
            value={filters.month}
            onChange={e => setFilters(p => ({...p, month: e.target.value}))}
          >
            <option value="ALL">All Months</option>
            {months.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
          <IconChevronDown/>
        </div>
      </div>

      {/* ════ EMPTY STATES ════ */}
      {invoices.length === 0 ? (
        <div className="inv-empty">
          <div className="inv-empty-icon"><IconEmptyState/></div>
          <strong>No invoices yet</strong>
          <p>Invoices will appear here after your first subscription payment.</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="inv-empty">
          <div className="inv-empty-icon"><IconEmptyState/></div>
          <strong>No matching invoices</strong>
          <p>Try adjusting your search or filter to find what you're looking for.</p>
        </div>
      ) : (
        <>
          {/* ════ CONTENT WRAPPER (Desktop Table & Mobile Cards) ════ */}
          <div className="inv-content">
            {/* ════ DESKTOP TABLE ════ */}
            <div className="inv-table-card">
              <div className="inv-table-scroll">
                <table className="inv-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Invoice</th>
                    <th>Billing Cycle</th>
                    <th>Base Price</th>
                    <th>Overage</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((inv, i) => (
                    <tr key={inv.id}>
                      <td>{i + 1}</td>
                      <td>
                        <div className="inv-num-cell">
                          <div className="inv-num-icon"><IconInvoice/></div>
                          <span className="inv-num-text">{inv.invoiceNumber}</span>
                        </div>
                      </td>
                      <td style={{fontWeight:600, color:"#334155"}}>{inv.billingCycleLabel || inv.billingMonth || "-"}</td>
                      <td><span className="inv-amount-secondary">₹{inv.basePrice}</span></td>
                      <td><span className="inv-amount-secondary">₹{inv.overageAmount}</span></td>
                      <td><span className="inv-amount-total">₹{inv.totalAmount}</span></td>
                      <td>
                        <span className={`inv-status ${statusClass(inv.status)}`}>
                          <span className="inv-status-dot"/>
                          {inv.status}
                        </span>
                      </td>
                      <td>
                        <button className="inv-download-btn" onClick={() => downloadInvoice(inv.id)}>
                          <IconDownload/> Download
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

            {/* ════ MOBILE CARDS ════ */}
            <div className="inv-card-list">
              {filtered.map((inv, i) => (
                <div className="inv-mobile-card" key={inv.id}>
                  <div className="inv-mobile-card-header">
                    <div className="inv-num-cell">
                      <div className="inv-num-icon"><IconInvoice/></div>
                      <span className="inv-num-text">{inv.invoiceNumber}</span>
                    </div>
                    <span className={`inv-status ${statusClass(inv.status)}`}>
                      <span className="inv-status-dot"/>
                      {inv.status}
                    </span>
                  </div>

                  <div className="inv-mobile-row">
                    <span className="inv-mobile-label">Billing Cycle</span>
                    <span className="inv-mobile-val">{inv.billingCycleLabel || inv.billingMonth || "-"}</span>
                  </div>
                  <div className="inv-mobile-row">
                    <span className="inv-mobile-label">Base Price</span>
                    <span className="inv-mobile-val">₹{inv.basePrice}</span>
                  </div>
                  <div className="inv-mobile-row">
                    <span className="inv-mobile-label">Overage</span>
                    <span className="inv-mobile-val">₹{inv.overageAmount}</span>
                  </div>
                  <div className="inv-mobile-row">
                    <span className="inv-mobile-label">Total</span>
                    <span style={{fontWeight:800,color:"#1d4ed8",fontSize:"15px"}}>₹{inv.totalAmount}</span>
                  </div>

                  <div className="inv-mobile-footer">
                    <button className="inv-download-btn" onClick={() => downloadInvoice(inv.id)}>
                      <IconDownload/> Download Receipt
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SubscriptionInvoicesPage;